import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { MatOption, MatOptionModule } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { LocationService } from '../../../core/services/location/location/location.service'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { provideNgxMask } from 'ngx-mask'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { ModalSupplierComponent } from '../../person/supplier/modal_supplier/modal-supplier.component'
import moment from 'moment/moment'
import { convertCurrency, removeAccents } from '../../../shared/utils/utils'
import { CommonModule } from '@angular/common'
import { map, Observable, startWith } from 'rxjs'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { ModalLegalEntityClientSubClientComponent } from '../../customer/modal_client_subClient/modal-legal-entity-client-subclient/modal-legal-entity-client-subclient.component'
import { ParadaItinerarioEditorComponent } from '../../../shared/components/parada-itinerario-editor/parada-itinerario-editor.component'
import { ParadaItinerario } from '../../../core/models/parada-itinerario.model'
import { apenasParadasP } from '../../../shared/utils/parada-itinerario.util'
import { DialogChooseComponent } from '../../../shared/components/dialog-to-choose/dialog-to-choose.component'
import { DialogChooseUniqueComponent } from '../../../shared/components/dialog-to-choose-unique/dialog-to-choose-unique.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatTooltip } from '@angular/material/tooltip'

interface LocationModel {
  id: number
  descricao: string
  cidade: string
  estado: string
}

@Component({
  selector: 'tariff-edit',
  imports: [
    CommonModule,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatSlideToggle,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    MatOptionModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatTooltip,
    ParadaItinerarioEditorComponent,
  ],
  templateUrl: './tariff-edit.component.html',
  styleUrl: './tariff-edit.component.scss',
  providers: [
    TariffService,
    TariffTypeService,
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class TariffEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private tariffService: TariffService,
    private tariffTypeService: TariffTypeService,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<TariffEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    this.item = data
  }
  datepicker = viewChild<MatDatepicker<any>>('birth')
  @Output() responseEdit = new EventEmitter()

  filteredOrigins!: Observable<LocationModel[]>
  filteredDestinations!: Observable<LocationModel[]>
  displayLocation = (loc: LocationModel | null): string =>
    loc ? `${loc.cidade} - ${loc.estado}` : ''

  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading = false
  listTypeTariff: any[] = []
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listServiceSpecification: any[] = []

  clientSelected: any = {}
  supplierSelected: any = {}
  subClient = false

  paradas: ParadaItinerario[] = []
  paradasOriginais: ParadaItinerario[] = []
  duplicateMode = false
  loadingDuplicate = false

  get editorLocation() {
    const origin = this.form.get('origin')?.value
    const destination = this.form.get('destination')?.value
    return {
      cityOrigin: origin?.cidade,
      stateOrigin: origin?.estado,
      cityDestination: destination?.cidade,
      stateDestination: destination?.estado,
    }
  }

  ngOnInit(): void {
    this.getTypeTariff()
    this.getLocation()
    this.getTypeService()
    this.getTypeVehicle()
    this.getTypeDriver()
    this.getServiceSpecification(this.item.tipoServicoId, true)
    this.createForm()
    this.loadParadas()
  }

  loadParadas(): void {
    if (!this.item?.id) return
    this.tariffService.getParadas(this.item.id).subscribe({
      next: (response: ResponseRequestModel) => {
        const paradas = apenasParadasP(response?.data) as ParadaItinerario[]
        this.paradas = paradas
        this.paradasOriginais = paradas.map((p) => ({ ...p }))
      },
      error: (err) => console.error(err),
    })
  }

  enterDuplicateMode(): void {
    this.duplicateMode = true
    const f = this.form
    f.get('tariffType')!.enable()
    f.get('serviceType')!.enable()
    f.get('specificationService')!.enable()
    f.get('vehicleType')!.enable()
    f.get('driverType')!.enable()
    f.get('origin')!.enable()
    f.get('destination')!.enable()
    f.get('urbanPerimeter')!.enable()
    f.get('supplier')!.enable()
    // cliente só é editável quando não é tarifário tg.mob (tipo 1)
    if (f.get('tariffType')!.value != 1) f.get('client')!.enable()
  }

  cancelDuplicateMode(): void {
    this.duplicateMode = false
    this.createForm()
    this.getLocation()
    this.paradas = this.paradasOriginais.map((p) => ({ ...p }))
  }

  onParadasChange(list: ParadaItinerario[]): void {
    this.paradas = list
  }

  confirmDuplicate(): void {
    this.loadingDuplicate = true
    const model = this.createDuplicateModel()
    this.tariffService.createTariff(model).subscribe({
      next: (response: ResponseRequestModel) => {
        if (response.statusCode == 419) {
          this.dialogChooseStandard(model, response.data.IdOldTarrif)
        } else if (response.statusCode == 409) {
          this.dialogChooseUnique(model)
        } else {
          this.snackbar.success(response.message)
          this.responseEdit.emit(true)
          this.close()
        }
      },
      error: (err: any) => {
        if (err?.error?.statusCode == 409) {
          this.dialogChooseUnique(model)
        } else {
          this.snackbar.errorRequest(err)
        }
        this.loadingDuplicate = false
      },
      complete: () => {
        this.loadingDuplicate = false
      },
    })
  }

  private createTariffStandard(model: any, IdOldTarrif: string): void {
    this.loadingDuplicate = true
    this.tariffService
      .createTariffStandard({ oldStandardId: IdOldTarrif, tarifario: model })
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseEdit.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loadingDuplicate = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loadingDuplicate = false
        },
      })
  }

  private createTariffUnique(model: any): void {
    this.loadingDuplicate = true
    this.tariffService.createTariffUnique(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loadingDuplicate = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingDuplicate = false
      },
    })
  }

  private dialogChooseStandard(model: any, IdOldTarrif: string): void {
    const dialogRef = this.dialog.open(DialogChooseComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: 'Já existe um tarifário standard, deseja criá-lo como standard?',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response == true) {
        this.createTariffStandard(model, IdOldTarrif)
      }
    })
  }

  private dialogChooseUnique(model: any): void {
    const dialogRef = this.dialog.open(DialogChooseUniqueComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: '',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.createTariffUnique(model)
      }
    })
  }

  private createDuplicateModel() {
    const { id, ...rest } = this.createModel()
    return { ...rest, paradas: this.paradas }
  }

  getTypeTariff() {
    this.tariffTypeService.listTariffType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeTariff = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getLocation(): void {
    this.locationService.listLocation().subscribe({
      next: (resp: ResponseRequestModel) => {
        this.listLocation = resp.data

        this.initOriginFilter()

        const originItem = this.listLocation.find(
          (c) => c.id === this.item.origemId,
        )
        const destinationItem = this.listLocation.find(
          (c) => c.id === this.item.destinoId,
        )

        if (originItem) {
          this.form.get('origin')!.setValue(originItem)
        }
        if (destinationItem) {
          this.form.get('destination')!.setValue(destinationItem)
        }
      },
      error: (err) => console.error(err),
    })
  }

  private initOriginFilter(): void {
    this.filteredOrigins = this.form.get('origin')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        // Converte para string (tratando objetos LocationModel)
        if (typeof v === 'string') return v
        if (v && typeof v.cidade === 'string' && typeof v.estado === 'string')
          return `${v.cidade} - ${v.estado}`
        if (v && typeof v.descricao === 'string') return v.descricao
        return ''
      }),
      map((text) => removeAccents(text.toLowerCase())),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locCity = loc?.cidade || ''
          const locState = loc?.estado || ''
          const searchData = `${locDescription} ${locCity} ${locState}`
          return removeAccents(searchData.toLowerCase()).includes(searchText)
        })
      }),
    )

    this.filteredDestinations = this.form.get('destination')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        if (typeof v === 'string') return v
        if (v && typeof v.cidade === 'string' && typeof v.estado === 'string')
          return `${v.cidade} - ${v.estado}`
        if (v && typeof v.descricao === 'string') return v.descricao
        return ''
      }),
      map((text) => removeAccents(text.toLowerCase())),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locCity = loc?.cidade || ''
          const locState = loc?.estado || ''
          const searchData = `${locDescription} ${locCity} ${locState}`
          return removeAccents(searchData.toLowerCase()).includes(searchText)
        })
      }),
    )
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
  }

  getServiceSpecification(idType: number, checkLoad = false) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (checkLoad) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == this.item.servicoId
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  editTariff() {
    this.loading = true
    const model = this.createModel()
    this.tariffService.editTariff(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  validClient() {
    if (this.form.get('tariffType')!.value == 1 && this.clientSelected.id) {
      return false
    } else if (
      this.form.get('tariffType')!.value == 2 &&
      !this.clientSelected.id
    ) {
      return false
    } else {
      return true
    }
  }

  checkForm() {
    if (this.form.valid && this.validClient()) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item.id,
      tipoId: this.form.get('tariffType')!.value,
      origemId: this.form.get('origin')!.value?.id ?? 0,
      destinoId: this.form.get('destination')!.value?.id ?? 0,
      tipoServicoId: this.form.get('serviceType')!.value,
      servicoId: this.form.get('specificationService')!.value,
      tipoVeiculoId:
        this.form.get('vehicleType')!.value != ''
          ? this.form.get('vehicleType')!.value
          : 0,
      tipoMotoristaId:
        this.form.get('driverType')!.value != ''
          ? this.form.get('driverType')!.value
          : 0,
      clienteId: this.clientSelected.id ? this.clientSelected.id : 0,
      fornecedorId: this.supplierSelected.id ? this.supplierSelected.id : 0,
      custo: convertCurrency(this.form.get('cost')!.value),
      custoHoraExtra: convertCurrency(this.form.get('costOvertime')!.value),
      custoKmExtra: convertCurrency(this.form.get('costKmExtra')!.value),
      // ativo: this.form.get('active')!.value ? 'S' : 'N',
      ativo: 'S',
      dataValidade: moment(this.form.get('validity')!.value).format(
        'DD/MM/YYYY',
      ),
      perimetroUrbano: this.form.get('urbanPerimeter')!.value ? 'S' : 'N',
      // standard: this.form.get('standard')!.value ? 'S' : 'N',
      standard: 'N',
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariffType: ['', [Validators.required]],
      serviceType: ['', [Validators.required]],
      specificationService: ['', [Validators.required]],
      vehicleType: [''],
      driverType: [''],
      origin: ['', [Validators.required]],
      destination: ['', [Validators.required]],
      cost: ['', [Validators.required]],
      costOvertime: ['', [Validators.required]],
      costKmExtra: ['', [Validators.required]],
      validity: ['', [Validators.required]],
      // active: [''],
      client: [''],
      supplier: [''],
      // standard: [false],
      urbanPerimeter: [true],
    })
    this.form.get('tariffType')?.disable()
    this.form.get('serviceType')?.disable()
    this.form.get('specificationService')?.disable()
    this.form.get('vehicleType')?.disable()
    this.form.get('driverType')?.disable()
    this.form.get('origin')?.disable()
    this.form.get('destination')?.disable()
    this.form.get('client')?.disable()
    this.form.get('urbanPerimeter')?.disable()
    this.form.get('supplier')?.disable()
    this.fillForm()
  }

  fillForm() {
    this.form.get('client')!.disable()
    if (this.item.tipoId == 1) {
    } else if (this.item.tipoId == 2) {
      this.form.get('tariffType')!.disable()
      this.clientSelected = {
        id: this.item.clientId,
        descricao: this.item.cliente,
      }
    }
    this.supplierSelected = {
      id: this.item.fornecedorId,
      descricao: this.item.fornecedor ?? '',
    }
    this.subClient = this.item.subClient == 'S' ? true : false
    this.form.get('tariffType')!.setValue(this.item.tipoId)
    this.form.get('serviceType')!.setValue(this.item.tipoServicoId)
    this.form.get('specificationService')!.setValue(this.item.servicoId)
    this.form.get('vehicleType')!.setValue(this.item.tipoVeiculoId ?? '')
    this.form.get('driverType')!.setValue(this.item.tipoMotoristaId ?? '')
    this.form.get('origin')!.setValue(this.item.origemId)
    this.form.get('destination')!.setValue(this.item.destinoId)
    this.form.get('cost')!.setValue(convertCurrency(this.item.custo))
    this.form
      .get('costOvertime')!
      .setValue(convertCurrency(this.item.custoHoraExtra))
    this.form
      .get('costKmExtra')!
      .setValue(convertCurrency(this.item.custokmExtra))
    this.form
      .get('validity')!
      .setValue(moment(this.item.dataValidade, 'DD/MM/YYYY').toDate())
    // this.form
    //   .get('active')!
    //   .setValue(this.item.ativo.toLowerCase() == 's' ? true : false)
    this.form.get('client')!.setValue(this.item.cliente ?? '')
    this.form.get('supplier')!.setValue(this.item.fornecedor ?? '')
    // this.form
    //   .get('standard')!
    //   .setValue(this.item.standard.toLowerCase() == 's' ? true : false)
    this.form
      .get('urbanPerimeter')!
      .setValue(this.item.perimetroUrbano.toLowerCase() == 's' ? true : false)
  }

  onSelectionChangeService(event: MatSelectChange) {
    const specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
  }

  checkService(specificationService: any) {
    // if (specificationService) {
    //   if (
    //     specificationService.exigeVeiculo &&
    //     specificationService.exigeVeiculo.toLowerCase() == 's'
    //   ) {
    //     this.form.get('vehicleType')!.setValidators(Validators.required)
    //     this.form.get('driverType')!.setValidators(Validators.required)
    //     this.form.get('vehicleType')!.enable()
    //     this.form.get('driverType')!.enable()
    //   } else {
    //     this.form.get('vehicleType')!.clearValidators()
    //     this.form.get('driverType')!.clearValidators()
    //     this.form.get('vehicleType')!.disable()
    //     this.form.get('driverType')!.disable()
    //   }
    // }
  }

  onSelectionChangeTypeTarrif(event: MatSelectChange) {
    if (event.value == 1) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
      this.form.get('client')!.disable()
    } else {
      this.form.get('client')!.enable()
    }
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }

  addClient() {
    const dialogRef = this.dialog.open(
      ModalLegalEntityClientSubClientComponent,
      {
        // const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '1200px',
        minWidth: '1200px',
        maxHeight: '650px',
        data: {
          item: this.clientSelected,
          subClient: this.subClient,
          multiSelect: false,
        },
      },
    )
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.clientSelected = response.selection
          this.subClient = response.subClient
          this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
        } else {
          this.clientSelected = {}
          this.form.get('client')!.setValue('')
        }
      }
    })
  }

  openDatepicker() {
    this.datepicker()?.open()
  }
}
